import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowDown } from 'lucide-react';
import { HomeNav } from '../components/landing/home/HomeNav';
import { HomeFooter } from '../components/landing/home/HomeFooter';
import { HomeCTA } from '../components/landing/home/HomePrimitives';
import { CostEstimator } from '../components/landing/payg/CostEstimator';
import { PlanPair, ComparePlans, PriceDetails, Advantages, PaygFAQ } from '../components/landing/payg/PaygSections';
import { usePageMeta } from '../lib/usePageMeta';
import { useMarketingViewport } from '../components/landing/home/useMarketingViewport';
import '../components/landing/home/home.css';
import '../components/landing/home/home-readable.css';
import '../components/landing/home/pricing-page.css';
import '../components/landing/home/agency.css';
import '../components/landing/payg/payg.css';

export default function PricingPage() {
  const { hash } = useLocation();
  useMarketingViewport();
  usePageMeta('Pricing — Voxinity | True pay as you go', 'Voxinity is true pay as you go: full platform access, AI voice agents from $0.11/min, AI chat from $0.005 per message and $10 in free credit.');
  useEffect(() => { if (hash) requestAnimationFrame(() => document.getElementById(hash.slice(1))?.scrollIntoView()); else window.scrollTo(0, 0); }, [hash]);
  return <div id="top" className="homepage agency-site pr-page" data-testid="pricing-page"><HomeNav />
    <main data-testid="pricing-main">
      <section className="pr-hero" data-testid="pricing-hero"><div className="hm-container">
        <p className="hm-eyebrow hm-center" data-testid="pricing-eyebrow">PRICING</p>
        <h1 data-testid="pricing-headline">True pay as you go.<br /><em>Only pay for what you use.</em></h1>
        <p className="pr-intro" data-testid="pricing-intro">The full platform from day one. No contracts, no feature gates. Start with $10 in free credit and scale when you are ready.</p>
        <div className="ag-pricing-hero-action"><HomeCTA id="pricing-hero-start" to="/signup?plan=launchpad">Start pay as you go</HomeCTA><span data-testid="pricing-hero-note">No credit card required · $10 free credit</span></div>
        <div className="pr-hero-links"><a href="#calculator" data-testid="pricing-estimate-link">Estimate your cost<ArrowDown size={14} /></a></div>
      </div></section>
      <PlanPair /><CostEstimator /><ComparePlans /><Advantages /><PriceDetails /><PaygFAQ />
    </main><HomeFooter />
  </div>;
}
